import { Injectable } from '@angular/core';
import { combineLatest, Observable } from "rxjs";
import { BREAKPOINT } from "@spartacus/storefront";
import { filter, map, startWith } from "rxjs/operators";
import { CmsService, WindowRef } from "@spartacus/core";
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GenLayoutHandlerService {

  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string, breakpoint?: BREAKPOINT): any {
    if (section === 'header' || section === 'navigation') {
      const location = this.windowRef.nativeWindow?.location;
      const initialUrl = location ? location.pathname + location.search : this.router.url;
      const url$ = this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event) => event.urlAfterRedirects),
        startWith(initialUrl),
      );

      return combineLatest([slots$, url$]).pipe(
        map(([slots, url]) => {
          const tree = this.router.parseUrl(url);
          const path = tree.root.children['primary']?.segments.map(segment => segment.path).join('/');
          const isAutoShipCart = path === 'cart' && tree.queryParams['autoShip'] === 'true';
          return isAutoShipCart ? slots.filter(slot => slot !== 'NavigationBar') : slots;
        }),
      );
    }

    if (!section) {
      return combineLatest([
        this.cmsService.getCurrentPage()
          .pipe(
            map((page: any) => {
              const slotsWithComponents: string[] = [];

              for (let slot in page?.slots) {
                if (page.slots[slot]?.components?.length) {
                  slotsWithComponents.push(slot);
                }
              }
              return slotsWithComponents;
            })
          ),
        slots$
      ]).pipe(
        map(([slotsWithComponents, homeSlots]) => {
          return homeSlots.filter(homeSlot => slotsWithComponents.includes(homeSlot));
        })
      );
    }
    return slots$;
  }


  constructor(
    private cmsService: CmsService,
    private router: Router,
    private windowRef: WindowRef,
  ) {
  }
}
